import NiceModal, { useModal } from '@ebay/nice-modal-react'
import styles from './CheckInvitationCodeModal.module.less'
import AModal from '@/components/A/AModal/AModal'
import { Form, message } from 'antd'
import AInput from '@/components/A/AInput/AInput'
import { useRequest } from 'alova/client'
import { api } from '@/api'
import { useEffect, useState } from 'react'
import MiddleText from '@/components/MiddleText/MiddleText'
import { useTranslation } from 'react-i18next'


function CheckInvitationCodeModal() {
  const { t } = useTranslation()
  const modal = useModal()
  const { data } = useRequest(api.corp.getBindAgentCode, { immediate: true })
  const [agentCode, setAgentCode] = useState('')
  const [msg, setMsg] = useState('')
  const [codeHasBound, setCodeHasBound] = useState(false)
  const handleConfirm = async () => {
    if (!agentCode) {
      setMsg(t('modals.checkInvitationCodeModal.invitationCodePlaceholder'))
      return
    }
    try {
      await api.corp.bindAgentCode({ referralCode: agentCode }).send()
      modal.hide()
      message.success(t('modals.checkInvitationCodeModal.invitationCodeSuccess'))
    } catch (e) {
      const error = e as ApiError
      if (error.statusCode === 40001) {
        setMsg(t('modals.checkInvitationCodeModal.invitationCodeError'))
      } else {
        setMsg(error.statusMessage)
      }
    }
  }

  const handleCancel = () => {
    modal.hide()
  }

  useEffect(() => {
    if (data?.code) {
      setAgentCode(data.code)
    }
    setCodeHasBound(Boolean(data?.code))
  }, [data?.code])

  return (
    <AModal
      testId='account-check-invitation-code-modal'
      title={codeHasBound ? t('modals.checkInvitationCodeModal.invitationCode') : '填写推荐码'}
      open={modal.visible}
      className={styles.checkInvitationCodeModal}
      confirmText={t('modals.checkInvitationCodeModal.ok')}
      cancelText={t('modals.checkInvitationCodeModal.cancel')}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      afterClose={() => {
        modal.remove()
      }}
      footer={codeHasBound ? null : undefined}
    >
      <Form>
        <Form.Item className={styles.formItem} label={codeHasBound ? null : <MiddleText text={t('modals.checkInvitationCodeModal.invitationCode')} />}
          style={{ marginBottom: 0, }}
          validateStatus={msg ? 'error' : ''}
          help={msg} >
          <AInput testId='account-invitation-code-input' disabled={codeHasBound}
            value={agentCode} placeholder={t('modals.checkInvitationCodeModal.invitationCodePlaceholder')}
            onChange={(e) => {
              setAgentCode(e.target.value)
              setMsg('')
            }} />
        </Form.Item>
      </Form>
      {
        codeHasBound
          ? <p className={styles.desc}>{t('modals.checkInvitationCodeModal.invitationCodeDesc1')}</p>
          : <p className={styles.desc}>{t('modals.checkInvitationCodeModal.invitationCodeDesc2')}</p>
      }
    </AModal >
  )
}


export default NiceModal.create(CheckInvitationCodeModal)
